import axios from "axios";
import keycloak from "../keycloak";

const apiUrl = process.env.VUE_APP_API_URL;

export default class BaseApi {
    construct() {}

    static getApiUrl() {
        return apiUrl;
    }

    static async startRequest() {
        return true;
    }

    static getAxiosInstanceDownload(url) {
        return axios({
            url: url,
            method: "GET",
            responseType: "blob",
            headers: BaseApi.getAuthHeaders()
        });
    }

    static getAxiosInstance() {
        const instance = axios.create();

        instance.interceptors.request.use(async (config) => {
            try {
                await keycloak.updateToken(30);
            } catch (error) {
                console.error("Não foi possível renovar o token:", error);
            }

            config.headers = {
                ...(config.headers || {}),
                ...BaseApi.getAuthHeaders()
            };

            return config;
        });

        instance.interceptors.response.use(
            (response) => response,
            async (error) => {
                if (error?.response?.status === 401) {
                    try {
                        await keycloak.updateToken(30);

                        const originalRequest = error.config;
                        originalRequest.headers = {
                            ...(originalRequest.headers || {}),
                            ...BaseApi.getAuthHeaders()
                        };

                        return axios(originalRequest);
                    } catch (refreshError) {
                        console.error("Falha ao renovar token após 401:", refreshError);
                        keycloak.login();
                    }
                }

                return Promise.reject(error);
            }
        );

        return instance;
    }

    static getAuthHeaders() {
        const token = keycloak.token;

        return {
            Accept: "application/json",
            Authorization: token ? `Bearer ${token}` : ""
        };
    }
}